import { ISetPurchasingHistory } from '../reducers/purchasingHistory';
import { ActionTypes } from '../types/actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const setPurchasingHistory = (payload: any): ISetPurchasingHistory => ({
  type: ActionTypes.SET_PURCHASING_HISTORY,
  payload,
});
export const setPurchasingHistoryTags = (payload: string[]) => ({
  type: ActionTypes.SET_PURCHASING_HISTORY_TAGS,
  payload,
});
export const setPurchasingHistoryLoading = (payload: boolean) => ({
  type: ActionTypes.SET_PURCHASING_HISTORY_LOADING,
  payload,
});
export const setPurchasingHistorySetInn = (payload: string) => ({
  type: ActionTypes.SET_PURCHASING_HISTORY_INN,
  payload,
});

export const setPurchasingHistorySetErrors = (payload: string) => ({
  type: ActionTypes.SET_PURCHASING_HISTORY_ERRORS,
  payload,
});

export const setPurchaseHistoryComplaints = (payload: any) => ({
  type: ActionTypes.SET_PURCHASE_HISTORY_COMPLAINTS,
  payload,
});

export const setPurchaseHistoryContractsAggregates = (payload: any) => ({
  type: ActionTypes.SET_PURCHASE_HISTORY_CONTRACTS_AGGREGATES,
  payload,
});
